import { FC, HTMLAttributes } from 'react';
import cn from "classnames";
import st from "./Resizer.module.scss";

interface IResizerProps extends HTMLAttributes<HTMLDivElement> {
	isResizing?: boolean;
	resizeHandler: (event: unknown) => void;
};

const Resizer: FC<IResizerProps> = ( { isResizing, resizeHandler, className, ...otherProps } ) => (
	<div
		onMouseDown={resizeHandler}
		onTouchStart={resizeHandler}
		className={cn(st.resizer, className,  { 
			[st.isResizing]: isResizing 
		})}
		{...otherProps}
	/>
);

export default Resizer;
